/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetMerchant} from '../api'

export const useMutationBatchGetMerchant = createReactQueryMutationHook('batchGetMerchant', batchGetMerchant)
